import {
  approve,
  selfApprove,
  cancel,
  count,
  generate,
  get,
  getInvoices,
  getPastPR,
  index,
  initiate,
  post,
  put,
  getCreditDebitNotes,
  sendForApproval,
  process,
  hold,
  getMissedInvoices,
  putAdvanceRequest,
  processBulkInitiate,
  processInBulk,
  putOneClickBulkProcess,
  putCancelPaymentRequestProcessing,
  putSendOTPForPRsProcessing,
} from "src/api/payment-request";

import { index as indexBanks } from "src/api/bank";

import PaymentRequestForm from "src/modules/payments/components/PaymentRequestForm.vue";

import PastPaymentRequestsDrawer from "src/modules/payments/components/PastPaymentRequestsDrawer.vue";

import AssociatedPaymentsDataDrawer from "src/modules/payments/components/AssociatedPaymentsDataDrawer.vue";

import ProcessPaymentRequestForm from "src/modules/payments/components/ProcessPaymentRequestForm.vue";
import OneClickBulkProcessDrawer from "src/modules/payments/components/OneClickBulkProcessDrawer.vue";

const getInitialState = () => {
  return {
    paymentRequests: [],
    paymentRequest: {},
    counts: [],
    processPaymentRequest: {},
    bankCodes: [],
  };
};

export const usePaymentRequestStore = defineStore("payment-request", () => {
  const formState = ref({
    edit: false,
    open: false,
    view: false,
  });

  const pastPreviewDrawerState = ref({
    edit: false,
    open: false,
    view: false,
  });

  const assosciatedDrawerState = ref({
    edit: false,
    open: false,
    view: false,
  });

  const processPaymentDrawerState = ref({
    edit: false,
    open: false,
    view: false,
  });

  const {
    state: oneClickBulkProcessDrawerState,
    toggle: toggleOneClickBulkProcessDrawer,
  } = useDrawer({
    component: OneClickBulkProcessDrawer,
  });

  const togglePaymentRequestForm = (state = {}) => {
    formState.value = {
      edit: false,
      open: !formState.value.open,
      view: false,

      ...state,
    };

    const { toggleRightDrawer } = useAppStore();

    toggleRightDrawer(unref(formState).open, PaymentRequestForm, state.props);
  };

  const togglePastPaymentRequestsView = (state = {}) => {
    pastPreviewDrawerState.value = {
      edit: false,
      open: !pastPreviewDrawerState.value.open,
      view: false,
      ...state,
    };

    const { toggleNestedRightDrawer } = useAppStore();

    toggleNestedRightDrawer({
      component: PastPaymentRequestsDrawer,
      level: unref(pastPreviewDrawerState).level,
      open: unref(pastPreviewDrawerState).open,
      props: unref(pastPreviewDrawerState).props,
    });
  };

  const toggleAssociatedDataDrawer = (state = {}) => {
    assosciatedDrawerState.value = {
      edit: false,
      open: !assosciatedDrawerState.value.open,
      view: false,
      ...state,
    };

    const { toggleNestedRightDrawer } = useAppStore();

    toggleNestedRightDrawer({
      component: AssociatedPaymentsDataDrawer,
      level: unref(assosciatedDrawerState).level,
      open: unref(assosciatedDrawerState).open,
      props: unref(assosciatedDrawerState).props,
    });
  };

  const toggleProcessPaymentForm = (state = {}) => {
    processPaymentDrawerState.value = {
      edit: false,
      open: !processPaymentDrawerState.value.open,
      view: false,
      ...state,
    };

    const { toggleNestedRightDrawer } = useAppStore();

    toggleNestedRightDrawer({
      component: ProcessPaymentRequestForm,
      level: unref(processPaymentDrawerState).level,
      open: unref(processPaymentDrawerState).open,
      props: unref(processPaymentDrawerState).props,
    });
  };

  let state = reactive(getInitialState());

  const totalCount = computed(() => {
    let statuses = [
      "pending",
      "awaiting_approval",
      "approved",
      "initiated",
      "hold",
    ];

    return state.counts.reduce((totalCount, status) => {
      if (statuses.includes(status._id)) {
        return totalCount + status.count;
      }

      return totalCount;
    }, 0);
  });

  const approvePaymentRequest = async (pr) => {
    try {
      const response = await approve(pr);

      await getPaymentRequests();

      return response.data;
    } catch (error) {
      console.error(error);
    }
  };
  const selfApprovePaymentRequest = async (pr) => {
    try {
      const response = await selfApprove(pr);

      await getPaymentRequests();

      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

  const cancelPaymentRequest = async (pr) => {
    try {
      const response = await cancel(pr);

      await getPaymentRequests();

      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

  const generatePaymentRequest = async (pr) => {
    try {
      const response = await generate(pr);

      await getPaymentRequests();

      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

  const holdPaymentRequest = async (pr) => {
    try {
      const response = await hold(pr);

      await getPaymentRequests();

      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

  const getCounts = async () => {
    try {
      const response = await count();

      state.counts = response.data?.data || {};

      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

  const getPaymentRequest = async (id, role = "account") => {
    try {
      state.paymentRequest = state.paymentRequests.find((pr) => pr._id === id);

      const response = await get(id, role);

      state.paymentRequest = {
        ...state.paymentRequest,
        ...response.data?.data,
      };

      return state.paymentRequest;
    } catch (error) {
      console.error(error);
    }
  };

  const getPaymentRequestInvoices = async (options = {}) => {
    try {
      const response = await getInvoices(options);

      return response.data?.data || [];
    } catch (error) {
      console.error(error);
    }
  };

  const getMissedPaymentRequestInvoices = async (options = {}) => {
    try {
      const response = await getMissedInvoices(options);

      return response.data?.data || [];
    } catch (error) {
      console.error(error);
    }
  };

  const filters = ref({
    invc_id: null,
    status_cd: null,
    startDate: null,
    endDate: null,
  });

  const { filter, pagination, params } = usePagination(filters);

  const getPaymentRequests = async (options = {}) => {
    try {
      options = unref(options);

      if (options?.filters) {
        filters.value = options?.filters;

        delete options.filters;
      }

      const response = await index({
        params: unref(params),
        ...options,
      });

      state.paymentRequests = response.data?.data?.data || [];

      pagination.value.rowsNumber = response.data?.data?.count || 0;

      state.counts = response.data?.data?.status_counts || [];

      return state.paymentRequests;
    } catch (error) {
      console.error(error);
    }
  };

  const getBankCodes = async () => {
    try {
      let bankOptions = {
        params: {
          applies_to: "poshn",
        },
      };
      const bankResponse = await indexBanks(bankOptions);

      const bankCodes = bankResponse?.data?.data.map((bank) => bank.code) || [];

      state.bankCodes = bankCodes;
    } catch (error) {
      console.error(error);
    }
  };

  const getPaymentRequestsForBulkProcess = async (options = {}) => {
    try {
      const response = await index(options);

      const bankCodes = state?.bankCodes;

      const prs = response.data?.data?.data.map((pr) => {
        return {
          ...pr,
          bank_codes: bankCodes.join("|"),
        };
      });

      return prs || [];
    } catch (error) {
      console.error(error);
    }
  };

  const getPastPaymentRequests = async (options = {}) => {
    try {
      const response = await getPastPR(options);

      return response.data?.data?.data;
    } catch (error) {
      console.error(error);
    }
  };

  const initiatePaymentRequest = async (pr) => {
    try {
      const response = await initiate(pr);

      await getPaymentRequests();

      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

  const postPaymentRequest = async (pr) => {
    try {
      const response = await post(pr);

      return response;
    } catch (error) {
      console.error(error);
    }
  };

  const putPaymentRequest = async (pr) => {
    try {
      const response = await put(pr);

      return response;
    } catch (error) {
      console.error(error);
    }
  };

  const putAdvancePaymentRequest = async (pr) => {
    try {
      const response = await putAdvanceRequest(pr);

      return response;
    } catch (error) {
      console.error(error);
    }
  };

  const sendPaymentRequestForApproval = async (pr) => {
    try {
      const response = await sendForApproval(pr);

      await getPaymentRequests();

      return response;
    } catch (error) {
      console.error(error);
    }
  };

  const processPR = async (pr) => {
    try {
      pr._id = state?.paymentRequest?._id;

      const response = await process(pr);

      togglePaymentRequestForm({
        open: false,
      });

      await getPaymentRequests();

      return response;
    } catch (error) {
      console.error(error);
    }
  };

  const getCreditDebitNotesForPR = async (options = {}) => {
    try {
      const response = await getCreditDebitNotes(options);

      return response.data?.data;
    } catch (error) {
      console.error(error);
    }
  };

  const bulkInitiate = async (prs) => {
    try {
      const response = await processBulkInitiate(prs);

      await getPaymentRequests();

      return response;
    } catch (error) {
      console.error(error);
    }
  };

  const bulkProcess = async (prs) => {
    try {
      const response = await processInBulk(prs);

      await getPaymentRequests();

      return response;
    } catch (error) {
      console.error(error);
    }
  };

  const oneClickBulkProcess = async (payload) => {
    try {
      const response = await putOneClickBulkProcess(payload);

      await getPaymentRequests();

      return response;
    } catch (error) {
      console.error(error);
    }
  };

  const cancelPaymentRequestProcessing = async (payload) => {
    try {
      const response = await putCancelPaymentRequestProcessing(payload);

      await getPaymentRequests();

      return response;
    } catch (error) {
      console.error(error);
    }
  };

  const sendOTPForPRsProcessing = async (payload) => {
    try {
      const response = await putSendOTPForPRsProcessing(payload);

      return response;
    } catch (error) {
      console.error(error);
    }
  };
  const reset = () => {
    Object.assign(state, getInitialState());
  };

  return {
    togglePaymentRequestForm,
    togglePastPaymentRequestsView,
    toggleAssociatedDataDrawer,
    toggleProcessPaymentForm,
    formState,
    processPaymentDrawerState,

    oneClickBulkProcessDrawerState,
    toggleOneClickBulkProcessDrawer,

    filter,
    filters,
    pagination,

    ...toRefs(state),

    totalCount,

    getPaymentRequest,
    getPaymentRequests,
    postPaymentRequest,
    putPaymentRequest,

    generatePaymentRequest,
    getCounts,
    getPastPaymentRequests,
    getCreditDebitNotesForPR,
    getPaymentRequestInvoices,
    getMissedPaymentRequestInvoices,
    getPaymentRequestsForBulkProcess,

    cancelPaymentRequest,
    sendPaymentRequestForApproval,
    approvePaymentRequest,
    selfApprovePaymentRequest,
    initiatePaymentRequest,
    processPR,
    holdPaymentRequest,
    putAdvancePaymentRequest,
    bulkInitiate,
    bulkProcess,
    oneClickBulkProcess,
    cancelPaymentRequestProcessing,
    sendOTPForPRsProcessing,
    getBankCodes,

    reset,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(usePaymentRequestStore, import.meta.hot),
  );
}
